import { Consultation } from '@/graphql/types'
import { convertEnum } from '@/react/hooks/typesDisplay'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import dayjs from 'dayjs'
import React from 'react'
import { Card } from './Basics'

export interface Props {
  consultation: Pick<
    Consultation,
    'id' | 'gender' | 'age' | 'body' | 'title' | 'createdAt'
  >
}

export const ConsultationCard: React.FC<Props> = ({ consultation }) => {
  const displayAge = (age: number) => Math.floor(age / 10) * 10

  return (
    <Card key={consultation.id}>
      <p className="font-bold text-xl">{consultation.title}</p>
      <div className="mt-4 flex justify-between">
        <span className="font-bold text-gray-70">
          <FontAwesomeIcon
            className="text-app-color"
            style={{ fontSize: 18, marginRight: 7 }}
            icon={faUser}
          />
          {displayAge(consultation.age)}代 /{' '}
          {convertEnum('Gender', consultation.gender)}
        </span>
        {consultation?.createdAt && (
          <time className="text-gray-50">
            {dayjs(consultation?.createdAt).format('YYYY/MM/DD')}
          </time>
        )}
      </div>
      <p className="mt-2 text-lg whitespace-pre-line">{consultation.body}</p>
    </Card>
  )
}
